"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownContent = void 0;
var theme_ui_1 = require("theme-ui");
var __1 = require("../../..");
var DropdownContent = function (_a) {
    var children = _a.children, _b = _a.csx, csx = _b === void 0 ? {} : _b, alignItems = _a.alignItems;
    return (theme_ui_1.jsx(theme_ui_1.Flex, { sx: __assign(__assign({ flexDirection: "column", fontSize: __1.theme.fontSizes[6], width: "100%", backgroundColor: __1.theme.colors.offBlack }, getAlignmentStyles(alignItems)), csx) }, children));
};
exports.DropdownContent = DropdownContent;
var getAlignmentStyles = function (aligment) {
    if (aligment === "right") {
        return { justifyContent: "flex-end", textAlign: "right", margin: "42px 25px 42px 0" };
    }
    return { justifyContent: "flex-start", textAlign: "left", margin: "42px 0 42px 25px" };
};
